import React from "react";
import {
  FaFacebook,
  FaInstagramSquare,
  FaLinkedin,
  FaPinterest,
  FaClock,
  FaCalendarAlt,
} from "react-icons/fa";
import moment from "moment";
import MaxWidthWrapper from "../common/MaxWidthWrapper";
import SecondaryWidthWrapper from "../common/SecondaryWidthWrapper";
import classNames from "classnames";

interface Props {
  title: string;
  publishedAt: any;
  bannerImage: any;
  readingTime?: number;
}

const BlogHero: React.FC<Props> = ({ title, bannerImage, publishedAt, readingTime }) => {
  return (
    <div
      className={classNames(
        "relative flex items-center justify-center overflow-hidden bg-gradient-to-b to-hero-gradient-end pt-[15px] pb-[15px] xl:pt-[25px] xl:pb-[50px]",
        { "from-hero-gradient-start": true, "from-white": false }
      )}
    >
      <MaxWidthWrapper>
        <SecondaryWidthWrapper>
          <div className="mt-6 flex flex-col items-center justify-between gap-6 lg:flex-row lg:items-center">
            <p className="px-2 text-center text-2xl font-semibold text-[#012D13] lg:px-0 lg:text-left lg:text-4xl lg:!leading-[3rem]">
              {title}
            </p>

            <div className="flex flex-col items-center gap-4 lg:items-end">
              <div className="flex flex-col gap-3">
                <div className="flex items-center gap-2 text-gray-700">
                  <FaCalendarAlt className="text-primary" />
                  <span>{moment(publishedAt).format("MMM DD, YYYY")}</span>
                </div>
                {readingTime && (
                  <div className="flex items-center gap-2 text-gray-700">
                    <FaClock className="text-primary" />
                    <span>{readingTime} min read</span>
                  </div>
                )}
              </div>
              {/* <div className="flex justify-center gap-2"> */}
              {/* @ts-ignore  */}
              {/* <FaFacebook size={40} /> */}
              {/* @ts-ignore  */}
              {/* <FaInstagramSquare size={40} /> */}
              {/* @ts-ignore  */}
              {/* <FaLinkedin size={40} /> */}
              {/* @ts-ignore  */}
              {/* <FaPinterest size={40} /> */}
              {/* </div> */}
            </div>
          </div>

          <div className="relative w-full py-8">
            <div className=" absolute left-1/2 -top-36 -z-10 h-full w-full -translate-x-1/2"></div>
            <div className="h-full w-full overflow-hidden rounded-2xl">
              <img
                src={bannerImage?.media?.data?.[0]?.attributes?.url}
                className="relative h-full w-full object-cover"
                alt=""
              />
            </div>
          </div>
        </SecondaryWidthWrapper>
      </MaxWidthWrapper>
    </div>
  );
};

export default BlogHero;
